import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

// Widget de chat Brevo Conversations.
// Charge UNIQUEMENT pour les utilisateurs connectes : le composant n'est monte
// (depuis MainLayout) que lorsqu'un user est present. Reproduit fidelement le
// snippet officiel Brevo (file d'attente `BrevoConversations` + script async vers
// le head) de facon idempotente : pas de double injection au re-render / re-login,
// et fermeture du widget au demontage (logout) pour qu'il ne survive pas a la session.
// SIM ISOLE : widget Brevo neutralise (ID vide + src stark placeholder) pour ne
// PAS charger le script Brevo reel ni ouvrir de session chat sur le compte client.
const BREVO_CONVERSATIONS_ID = '';
const BREVO_SRC = 'https://neutralized.stark.a3n.fr/brevo-conversations.js';
const BREVO_SCRIPT_ID = 'brevo-conversations-script';

const BrevoChat = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const w = window as any;
    w.BrevoConversationsID = BREVO_CONVERSATIONS_ID;
    // File d'attente : tout appel a l'API Brevo fait avant le chargement du script
    // est empile puis rejoue une fois le widget pret (comportement du snippet officiel).
    w.BrevoConversations = w.BrevoConversations || function () {
      (w.BrevoConversations.q = w.BrevoConversations.q || []).push(arguments);
    };

    // Idempotence : si le script est deja dans le DOM, ne pas le reinjecter.
    if (!document.getElementById(BREVO_SCRIPT_ID)) {
      const s = document.createElement('script');
      s.id = BREVO_SCRIPT_ID;
      s.async = true;
      s.src = BREVO_SRC;
      if (document.head) document.head.appendChild(s);
    } else {
      // Script deja charge (re-login sans reload) : reafficher le widget.
      try { w.BrevoConversations('show'); } catch { /* widget pas encore pret : la queue gere */ }
    }

    return () => {
      // Logout / demontage : masquer le widget (pas de reload SPA -> il faut le cacher
      // explicitement). On garde le script en place pour un re-login instantane.
      try { w.BrevoConversations && w.BrevoConversations('hide'); } catch { /* rien a faire */ }
    };
  }, [user]);

  return null;
};

export default BrevoChat;
